import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { AuthCallback } from "@/components/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AiGenerator from "@/pages/AiGenerator";
import ManualBuilder from "@/pages/ManualBuilder";
import StandardTemplates from "@/pages/StandardTemplates";
import SavedPlans from "@/pages/SavedPlans";
import PlanView from "@/pages/PlanView";
import Pricing from "@/pages/Pricing";
import Diary from "@/pages/Diary";
import Calendar from "@/pages/Calendar";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/create/ai" element={<AiGenerator />} />
        <Route path="/create/manual" element={<ManualBuilder />} />
        <Route path="/templates" element={<StandardTemplates />} />
        <Route path="/saved" element={<SavedPlans />} />
        <Route path="/diary" element={<Diary />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/plan/:id" element={<PlanView />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
